import { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Sidebar from './components/Sidebar/Sidebar';
import Topbar from './components/Sidebar/Topbar';
import PrivateRoute from './components/Route/PrivateRoute';
import PublicRoute from './components/Route/PublicRoute';
import Login from './pages/login/Login';
import LogoutPage from './pages/login/Logout';
import SetPassword from './pages/login/SetPassword';
import CompaniesPage from './pages/admin/companies/CompaniesPage';
import ChargesPage from './pages/admin/charges/ChargesPage';
import CoreConfigPage from './pages/admin/config/CoreConfigPage';
import CoreDebugPage from './pages/admin/debug/CoreDebugPage';
import CoreMaintenancePage from './pages/admin/maintenance/CoreMaintenancePage';
import LegalDocumentsPage from './pages/admin/legal/LegalDocumentsPage';
import StaffPage from './pages/admin/staff/StaffPage';
import ReportsPage from './pages/admin/reports/ReportsPage';
import LearningPage from './pages/learning/LearningPage';
import NotFound from './pages/error_pages/NotFound';
import PermissionDenied from './pages/error_pages/PermissionDenied';
import InternalServerError from './pages/error_pages/InternalServerError';
import { AuthProvider } from './context/AuthContext';
import { MenuProvider } from './context/MenuContext';
import { setNavigateRef } from './utils/NavigationService';
import { ADMIN_HOME } from './utils/HomeNavigation';

import './assets/scss/main.scss';

const MainLayout = () => {
  const isMobile = useMediaQuery('(max-width:1000px)');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setNavigateRef(navigate);
  }, [navigate]);

  return (
    <div className="flex">
      <Topbar
        isMobile={isMobile}
        isCollapsed={isMobile ? false : isCollapsed}
        onToggleSidebar={isMobile ? () => setDrawerOpen((prev) => !prev) : () => setIsCollapsed((prev) => !prev)}
      />
      <Sidebar
        isMobile={isMobile}
        drawerOpen={drawerOpen}
        onDrawerToggle={() => setDrawerOpen((prev) => !prev)}
        isCollapsed={isMobile ? false : isCollapsed}
        onToggleSidebar={() => setIsCollapsed((prev) => !prev)}
      />
      <div className="content fullscreen">
        <Routes>
          <Route path="/admin/companies" element={<CompaniesPage />} />
          <Route path="/admin/reports" element={<ReportsPage />} />
          <Route path="/admin/charges" element={<ChargesPage />} />
          <Route path="/admin/config" element={<CoreConfigPage />} />
          <Route path="/admin/debug" element={<CoreDebugPage />} />
          <Route path="/admin/maintenance" element={<CoreMaintenancePage />} />
          <Route path="/admin/legal" element={<LegalDocumentsPage />} />
          <Route path="/admin/staff" element={<StaffPage />} />
          <Route path="/learning" element={<LearningPage />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <MenuProvider>
        <Router basename="/">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Routes>
              <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
              {/* Pública y sin PublicRoute: quien recibe el mail puede tener otra sesión abierta en este navegador. */}
              <Route path="/set-password" element={<SetPassword />} />
              <Route path="/" element={<Navigate to={ADMIN_HOME} replace />} />
              <Route path="/permission-denied" element={<PermissionDenied />} />
              <Route path="/internal-server-error" element={<InternalServerError />} />
              <Route path="/not-found" element={<NotFound />} />
              <Route path="*" element={<PrivateRoute><MainLayout /></PrivateRoute>} />
            </Routes>
          </LocalizationProvider>
        </Router>
      </MenuProvider>
    </AuthProvider>
  );
}

export default App;
